import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
    PAGE_HOME, PAGE_THREATS,
    PAGE_ESTIMATION, PAGE_ABOUT,
    PAGE_OFFER, PAGE_CONTACT, PAGE_EBOOK, PAGE_PRIVACY,
    PAGE_LEGAL, PAGE_WEBINAR, AVAILABLE_PAGES
} from '../config/pages';

const prevOpen = (current, prev) => {
    let open = false;
    if (current !== prev) {
        switch (current) {
            case PAGE_OFFER: {
                if (prev === PAGE_THREATS) {
                    open = true;
                } else {
                    open = false;
                }
                break;
            }
            case PAGE_ESTIMATION:
            case PAGE_ABOUT:
            case PAGE_CONTACT:
            case PAGE_PRIVACY:
            case PAGE_LEGAL:
            case PAGE_EBOOK:
            case PAGE_WEBINAR: {
                if (AVAILABLE_PAGES.indexOf(current) > AVAILABLE_PAGES.indexOf(prev)) {
                    open = true;
                }
                break;
            }
            default: {
                open = false;
                break;
            }
        }
    }
    return open;
};

const nextOpen = (current, next) => {
    let open = false;
    if (current !== next) {
        switch (current) {
            case PAGE_HOME: {
                if (next === PAGE_THREATS || next === PAGE_OFFER) {
                    open = false;
                } else {
                    open = true;
                }
                break;
            }
            case PAGE_THREATS: {
                if (next === PAGE_HOME) {
                    open = false;
                } else {
                    open = true;
                }
                break;
            }
            case PAGE_OFFER: {
                if (next === PAGE_HOME || next === PAGE_THREATS) {
                    open = false;
                } else {
                    open = true;
                }
                break;
            }
            case PAGE_ESTIMATION:
            case PAGE_ABOUT:
            case PAGE_CONTACT:
            case PAGE_PRIVACY:
            case PAGE_LEGAL:
            case PAGE_EBOOK:
            case PAGE_WEBINAR: {
                if (AVAILABLE_PAGES.indexOf(current) < AVAILABLE_PAGES.indexOf(next)) {
                    open = true;
                }
                break;
            }
            default: {
                open = false;
                break;
            }
        }
    }
    return open;
};

class Cover extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    componentWillReceiveProps(nextProps) {
        const { type, page: current } = this.props;
        const { page: next, firstLoad } = nextProps;

        if (!firstLoad) {
            const open = type === 'prev' ? prevOpen(current, next) : nextOpen(current, next);
            this.setState({ open });
            if (open === true) {
                this.setState({ open });
                setTimeout(() => this.setState({ open: false }), 1600);
            }
        }
    }

    render() {
        const { open } = this.state;
        const { type } = this.props;
        const coverClassName = cx('container-cover', {
            open,
            prev: type === 'prev',
            next: type === 'next'
        });
        return (
            <div className={ coverClassName } id={ coverClassName }/>
        );
    }
}

Cover.propTypes = {
    type: PropTypes.oneOf(['prev', 'next']).isRequired,
    page: PropTypes.string.isRequired,
    firstLoad: PropTypes.bool.isRequired
};

export default Cover;



// WEBPACK FOOTER //
// ./src/components/Cover.jsx